import React, { forwardRef, useEffect, useImperativeHandle } from "react";
import useForm from '../../../../hooks/useForm';
import { FormField } from '@prosolve/common-components-ui'

export default forwardRef(({
  eventData = {},
  eventProducts = [],
  onUpdate
}, ref) => {
  const {
    deliveryNotes
  } = eventData

  const formSchema = {
    requiredFields: [],
    optionalFields: ['deliveryNotes'],
    initData: {
      deliveryNotes: deliveryNotes || 'Delivered as planned.'
    }
  };

  const formData = useForm(formSchema)

  const getData = (newerValues) => {
    const emptyEventProducts = eventProducts.map(p => {
      p.numberOfDeliveredUnits = p.numberOfExpectedUnits
      p.actualDeliveryPriceTotal = p.expectedDeliveryPriceTotal
      p.status = "Delivered"
      return p
    })

    return {
      ...formData.values,
      eventProducts: emptyEventProducts,
      ...(newerValues || {})
    }
  }

  useImperativeHandle(ref, () => {
    return {
      isValid: formData.isValid
    };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    onUpdate(getData())
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formData.values])

  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      gap: '15px'
    }}>
      <div style={{ paddingTop: '10px'}}>
        Notes (optional — content or teacher changes or details for CS)
      </div>
      <div>
        <FormField
          style={{ flex: 1 }}
          fieldId='deliveryNotes'
          type='textarea'
          placeholder=''
          formData={formData}
        />
      </div>
    </div>
  )
})
